module.exports = __webpack_public_path__ + "img/ic_points.ad643d00.svg";